import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { Store } from '@ngrx/store';

import { IAppState } from '../../interfaces/app-state';
import { BaseLayoutComponent } from '../base-layout/base-layout.component';
import { HttpService } from '../../services/http/http.service';
import { IOption } from '../../ui/interfaces/option';
import { Content } from '../../ui/interfaces/modal';
import { TCModalService } from '../../ui/services/modal/modal.service';
import { IPatient } from '../../interfaces/patient';
import * as PatientsActions from '../../store/actions/patients.actions';
import * as SettingsActions from '../../store/actions/app-settings.actions';

@Component({
  selector: 'vertical-layout',
  templateUrl: './vertical.component.html',
  styleUrls: [
    '../base-layout/base-layout.component.scss',
    './vertical.component.scss'
  ]
})
export class VerticalLayoutComponent extends BaseLayoutComponent implements OnInit, AfterViewInit {
  patientForm: FormGroup;
  gender: IOption[];
  currentAvatar: string | ArrayBuffer;
  defaultAvatar: string;

  constructor(
    store: Store<IAppState>,
    fb: FormBuilder,
    httpSv: HttpService,
    router: Router,
    elRef: ElementRef,
    private modal: TCModalService,
    private cdRef: ChangeDetectorRef
  ) {
    super(store, fb, httpSv, router, elRef);

    this.gender = [
      {
        label: 'Male',
        value: 'male'
      },
      {
        label: 'Female',
        value: 'female'
      }
    ];
    this.defaultAvatar = 'assets/content/anonymous-400.jpg';
    this.currentAvatar = this.defaultAvatar;
  }
  restaurant_image
  restoID
  resto=[]
  ngOnInit() {
    super.ngOnInit();
    this.restoID = localStorage.getItem('restoID');
    this.getdata()
    this.store.dispatch(new SettingsActions.Update({ layout: 'vertical' }));
  }

  ngAfterViewInit() {
    this.cdRef.detectChanges();
  }

  // open modal window
  openModal<T>(body: Content<T>, header: Content<T> = null, footer: Content<T> = null, options: any = null) {
    this.initPatientForm();

    this.modal.open({
      body: body,
      header: header,
      footer: footer,
      options: options
    });
  }

  // close modal window
  closeModal() {
    this.modal.close();
    this.patientForm.reset();
    this.currentAvatar = this.defaultAvatar;
  }

  // upload new file
  onFileChanged(inputValue: any) {
    let file: File = inputValue.target.files[0];
    let reader: FileReader = new FileReader();

    reader.onloadend = () => {
      this.currentAvatar = reader.result;
    };

    reader.readAsDataURL(file);
  }

  // init form
  initPatientForm() {
    this.patientForm = this.fb.group({
      img: [],
      name: ['', Validators.required],
      number: ['', Validators.required],
      age: ['', Validators.required],
      gender: ['', Validators.required],
      address: ['', Validators.required]
    });
  }

  // add new patient
  addPatient(form: FormGroup) {
    if (form.valid) {
      let newPatient: IPatient = form.value;

      newPatient.img = this.currentAvatar;
      newPatient.id = '23';
      newPatient.status = 'Pending';
      newPatient.lastVisit = '';

      this.store.dispatch(new PatientsActions.Add(newPatient));
      this.closeModal();
      this.patientForm.reset();
    }
  }
 
  getdata() {
    this.httpSv.getReturant(this.restoID).subscribe(
      response => {
        if (response['status'] == true) {
          // Swal.fire("Password Successfully Changed")
          // this.router.navigate(['/public/sign-in']);
          // this.appointments = response.result.data;
          // this.router.navigate(['/public/sign-in']);
          this.resto = response['result'].data;
          this.restaurant_image = this.resto['restaurant_image'];
         
          //  this.getrestoDetails();
        }
        else {
          // this.resetFormLoad = false;
          // Swal.fire("Something Went Wrong")
        }

      }
    )
  }
}
